<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addEditInvoice :activeTab="activeTab"></addEditInvoice>
    </v-dialog>
</template>

<script>
    import addEditInvoice from '../Shared/AddInvoice.vue'

    // Settings Types
    import {
        Invoice
    } from '../../store/namespace-helper'

    export default {
      name: 'invoice-dialog',
      components: {
        addEditInvoice
      },
      props: {
        activeTab: {
          type: Number,
          default: 0
        }
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[Invoice.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Invoices/AddInvoiceDialog.vue